import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { useAuth } from "../hooks/useAuth";

const StatCard = ({ label, value }) => (
  <Paper elevation={2} sx={{ p: 2, borderRadius: 0 }}>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h5" fontWeight={600}>
      {value}
    </Typography>
  </Paper>
);

const DashboardNew = () => {
  const { username, fullName, logout } = useAuth(); 

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Welcome, {fullName || username}!
      </Typography>

      <button onClick={logout}>Logout</button>

     
    </>
  );
};

export default DashboardNew;
